export default function getCurrency(price, currency = "USD") {
    // Ensure numeric value; fallback to 0 if NaN
    const num = Number(price);
    const safePrice = isNaN(num) ? 0 : num;
    const formattedPrice = safePrice.toLocaleString("en-US", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formattedPrice;
  }
  